const credentials = {
  apiKey: "AIzaSyBVYxOBhD-0sr2k1G4-z-8ymhBKeFkIN18",
  authDomain: "mytypequiz.firebaseapp.com",
  projectId: "mytypequiz",
  storageBucket: "mytypequiz.appspot.com",
  messagingSenderId: "743299308973",
  appId: "1:743299308973:web:55a04a5dec3904af621524",
  measurementId: "G-JWKBFPBQKJ"
};

export default credentials;